import type { CourseDraftCreatePriceCurrency } from './courseDraftCreatePriceCurrency';

/**
 * 코스 가격 정보
 * @nullable
 */
export type CourseDraftCreatePrice = {
  /**
   * 가격 (0은 무료)
   * @minimum 0
   */
  amount: number;
  /** 통화 코드 */
  currency: CourseDraftCreatePriceCurrency;
} | null;
